import { render, staticRenderFns } from "./input-fatepoints.vue?vue&type=template&id=082e5d7c&scoped=true&"
import script from "./input-fatepoints.vue?vue&type=script&lang=js&"
export * from "./input-fatepoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e5d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('082e5d7c')) {
      api.createRecord('082e5d7c', component.options)
    } else {
      api.reload('082e5d7c', component.options)
    }
    module.hot.accept("./input-fatepoints.vue?vue&type=template&id=082e5d7c&scoped=true&", function () {
      api.rerender('082e5d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input-fatepoints.vue"
export default component.exports